import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { cleanPictures as cleanPicturesReducer, getVersionsCitroenFailure, cleanColors as cleanColorsReducer ,setVersionSelected as setVersionSelectedReducer, getVersionsCitroenRequest, getVersionsCitroenSuccess, getModelsCitroenFailure, getModelsCitroenRequest, getModelsCitroenSuccess, getTokenCitroenFailure, getTokenCitroenRequest, getTokenCitroenSuccess, getOportunitiesRequest, getOportunitiesSuccess, getOportunitiesFailure, getCitroenColorsRequest, getCitroenColorsSuccess, getCitroenColorsFailure, getCitroenPicturesRequest, getCitroenPicturesSuccess, getCitroenPicturesFailure, getCitroenComunesRequest, getCitroenComunesSuccess, getCitroenComunesFailure, getCitroenDealershipsRequest, getCitroenDealershipsSuccess, getCitroenDealershipsFailure, getCitroenRegionsRequest, getCitroenRegionsSuccess, getCitroenRegionsFailure, getCitroenAdditionalPricesRequest, getCitroenAdditionalPricesSuccess, getCitroenAdditionalPricesFailure, getCodigoPorContratoRequest, getCodigoPorContratoSuccess, getCodigoPorContratoFailure, cleanSuccessOportunitiesFetching as cleanSuccessOportunitiesFetchingReducer } from "../reducers/citroen";
import { GetState } from "../config/store";
import { COLORS } from "../constants/app";

export const getCitroenToken = (type?: string) => (dispatch: Dispatch, getState: GetState) => _getCitroenToken(type || "",dispatch, getState);
const _getCitroenToken = async (type: string, dispatch: Dispatch, getState: GetState) => {
    try {
        if(type === "rehydrate"){
            dispatch({ type: getTokenCitroenRequest, payload: "rehydrate" });
        }else{ 
            dispatch({ type: getTokenCitroenRequest});

        }
        const formData = new FormData();
        formData.append("user_name",process.env.REACT_APP_CITROEN_USER ?? "");
        formData.append("password",process.env.REACT_APP_CITROEN_PASSWORD ?? "")

        const response = await fetch(`${api.citroenLogin}`,{
            method: "POST",
            body: formData
        });
        
        const json = await response.json();

        dispatch({ type: getTokenCitroenSuccess, payload: json });
        getCitroenRegions()(dispatch, getState)

    } catch (error: any) {
        console.log("getToken ERROR",error)
        dispatch({ type: getTokenCitroenFailure, payload: error});
    }
};

export const getCitroenModels = () => (dispatch: Dispatch, getState: GetState) => _getCitroenModels(dispatch, getState);
const _getCitroenModels = async (dispatch: Dispatch, getState: GetState) => {
    try {
        const { token } = getState().citroen.token;

        if(!token) throw "Token undefined";

        dispatch({ type: getModelsCitroenRequest });

        const response = await fetch(`${api.citroenModels}?token=${token}&marca=citroen`);
        
        const json = await response.json();

        dispatch({ type: getModelsCitroenSuccess, payload: json.Modelos.map((model: any) => {
            return {
                ...model
                //CodigoModelo: model?.CodigoModelo === "1SX8N" ? "1SX8" : model?.CodigoModelo === "1SD3MT" ? "1SD3" : model?.CodigoModelo
            }
        }) });
        getOportunities()(dispatch, getState)

    } catch (error) {
        dispatch({ type: getModelsCitroenFailure, payload: error});
    }
};

export const getCitroenComunes = (region_id: string) => (dispatch: Dispatch, getState: GetState) => _getCitroenComunes(region_id,dispatch, getState);
const _getCitroenComunes = async (region_id: string ,dispatch: Dispatch, getState: GetState) => {
    try {
        const { token } = getState().citroen.token;

        if(!token) throw "Token undefined";

        dispatch({ type: getCitroenComunesRequest });

        const response = await fetch(`${api.citroenComunes}?token=${token}&marca=citroen&codigo_region=${region_id}`);
        
        const json = await response.json();

        dispatch({ type: getCitroenComunesSuccess, payload: json?.Comunas});

    } catch (error) {
        dispatch({ type: getCitroenComunesFailure, payload: error});
    }
};

export const getCitroenDealearships = (comune_id: string) => (dispatch: Dispatch, getState: GetState) => _getCitroenDealearships(comune_id,dispatch, getState);
const _getCitroenDealearships = async (comune_id: string, dispatch: Dispatch, getState: GetState) => {
    try {
        const { token } = getState().citroen.token;

        if(!token) throw "Token undefined";

        dispatch({ type: getCitroenDealershipsRequest });

        const response = await fetch(`${api.citroenDealerships}?token=${token}&marca=citroen&codigo_comuna=${comune_id}`);
        
        const json = await response.json();

        dispatch({ type: getCitroenDealershipsSuccess, payload: json?.Concesionarios});

    } catch (error) {
        dispatch({ type: getCitroenDealershipsFailure, payload: error});
    }
};

export const getCitroenRegions = () => (dispatch: Dispatch, getState: GetState) => _getCitroenRegions(dispatch, getState);
const _getCitroenRegions = async (dispatch: Dispatch, getState: GetState) => {
    try {
        const { token } = getState().citroen.token;

        if(!token) throw "Token undefined";

        dispatch({ type: getCitroenRegionsRequest });

        const response = await fetch(`${api.citroenRegions}?token=${token}&marca=citroen`);
        
        const json = await response.json();

        dispatch({ type: getCitroenRegionsSuccess, payload: json?.Regiones});

    } catch (error) {
        console.log("getCitroenRegions error",error)
        dispatch({ type: getCitroenRegionsFailure, payload: error});
    }
};

export const getAdditionalPrices = (model: string) => (dispatch: Dispatch, getState: GetState) => _getAdditionalPrices(model, dispatch, getState);
const _getAdditionalPrices = async (model: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getCitroenAdditionalPricesRequest });

        const { token } = getState().citroen.token;

        const { vehicle } = getState().buy;

        if(!token) throw "Token undefined";

        const response = await fetch(`${api.citroenPrices}?token=${token}&codigo_producto=${vehicle?.codigo_producto}&solo_web=1`);
        
        const json = await response.json();
        if(!json?.lista_precios?.length) throw json;
        //@ts-ignore
        const productosUnicos = [...new Set(json.lista_precios.map(JSON.stringify))].map(JSON.parse);
        
        dispatch({ type: getCitroenAdditionalPricesSuccess, payload: productosUnicos });
        
    } catch (error) {
        dispatch({ type: getCitroenAdditionalPricesFailure, payload: error});
    }
};

export const getCodigoPorContrato = (product_id: string) => (dispatch: Dispatch, getState: GetState) => _getCodigoPorContrato(product_id, dispatch, getState);
const _getCodigoPorContrato = async (product_id: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getCodigoPorContratoRequest });

        const { token } = getState().citroen.token;

        if(!token) throw "Token undefined";

        const response = await fetch(`${api.citroenContracts}?token=${token}&codigo_producto=${product_id}`);
        
        const json = await response.json();

        dispatch({ type: getCodigoPorContratoSuccess, payload: json?.contrato_x_producto });
        
    } catch (error) {
        dispatch({ type: getCodigoPorContratoFailure, payload: error});
    }
};

export const getCitroenVersions = (modelId: string) => (dispatch: Dispatch, getState: GetState) => _getCitroenVersions(modelId, dispatch, getState);
const _getCitroenVersions = async ( modelId: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getVersionsCitroenRequest });

        const { token } = getState().citroen.token;

        if(!token) throw "Token undefined";

        const response = await fetch(`${api.citroenVersions}?token=${token}&codigo_modelo=${modelId}`);
        
        const json = await response.json();

        dispatch({ type: getVersionsCitroenSuccess, payload: json.versiones });
        
    } catch (error) {
        dispatch({ type: getVersionsCitroenFailure, payload: error});
    }
};


export const getOportunities = () => (dispatch: Dispatch, getState: GetState) => _getOportunities( dispatch, getState);
const _getOportunities = async (dispatch: Dispatch, getState: GetState) => {
    try {
        const { token } = getState().citroen.token;
        if(!token) throw "Token undefined";

        dispatch({ type: getOportunitiesRequest });
        
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}publications/media/citroen/opportunities`);
        const json = await response.json();

        const models = [...getState().citroen.models];
        const responseParsed : any = {};
        let total = 0;
        const oportunities = models.map((mod) => {
            let count = 0;
            let minValuesID = "";
            let minPriceValue = 0;
            json?.data?.forEach((jso: any) => {
                if(mod?.CodigoModelo === jso?.codigo_modelo){
                    total++;
                    if(Array.isArray(responseParsed[`${mod.CodigoModelo}`])){
                        if(minPriceValue !== 0 && jso?.precio_desde < minPriceValue){
                            minPriceValue = jso?.precio_desde;
                            minValuesID = jso?.vin;
                        }
                        responseParsed[`${mod.CodigoModelo}`].push({...jso,...mod})
                    }
                    else{
                        minValuesID = jso?.vin;
                        minPriceValue = jso?.precio_desde;
                        responseParsed[`${mod.CodigoModelo}`] = [{...jso,...mod}]
                    }
                    count++;
                }
            });
            const finded = (Array.isArray(responseParsed[`${mod.CodigoModelo}`]) && responseParsed[`${mod.CodigoModelo}`]?.length) ? responseParsed[`${mod.CodigoModelo}`].find((resp: any) => resp?.vin === minValuesID) : undefined;
            return {
                ...mod, 
                quantity: count,
                ...(finded ? {...finded} : {}),
                minValuesID,
                minPriceValue
            }
        } ).filter((model) => model.quantity > 0);        
        dispatch({ type: getOportunitiesSuccess, payload: { oportunities, total: json.data?.length, responseParsed }  });
    } catch (error) {
        dispatch({ type: getOportunitiesFailure, payload: error});
    }
};

export const getCitroenColors = (cod: string) => (dispatch: Dispatch, getState: GetState) => _getCitroenColors(cod,dispatch,getState);
const _getCitroenColors = async (cod: string,dispatch: Dispatch ,getState: GetState) => {
    try {

        dispatch({ type: getCitroenColorsRequest });

        const patron = /[- ]/g;
        const replacedCod = cod.replace(patron, "_")

        const response = await fetch(`${process.env.REACT_APP_API_CITROEN_PUBLICATIONS}/media/${replacedCod}/colors`);

        const json = await response.json();
        const parsed = json.data.map((val: string) => ({
            code: val, 
            //@ts-ignore
            color: COLORS[replacedCod][val]
        }));

        setTimeout(() => {
            dispatch({ type: getCitroenColorsSuccess, payload: parsed });
        },1000);
        
    } catch (err) {
        console.log("err",err)
        dispatch({ type: getCitroenColorsFailure, payload: err });
    }
}

export const cleanColors = (value: any) => (dispatch: Dispatch) =>  _cleanColors(value, dispatch);
export const _cleanColors = async (value: any, dispatch: Dispatch) => dispatch({ type: cleanColorsReducer });

export const getCitroenPictures = (cod: string, color: string) => (dispatch: Dispatch, getState: GetState) => _getCitroenPictures(cod, color,dispatch,getState);
const _getCitroenPictures = async (cod: string, color: string, dispatch: Dispatch ,getState: GetState) => {
    try {

        dispatch({ type: getCitroenPicturesRequest });

        const patron = /[- ]/g;
        const replacedCod = cod.replace(patron, "_")

        const response = await fetch(`${process.env.REACT_APP_API_CITROEN_PUBLICATIONS}/media/${replacedCod}?colorId=${color.replaceAll("/","_")}`,);
        
        const json = await response.json();
        const pictures = {};
        let newPictures: any = {};
        if(Object.keys(pictures).length){
            newPictures = {
                ...pictures,
                [`${color}`]: json?.data
            }
        }
        else{
            newPictures[`${color}`] = json?.data
        }        
        dispatch({ type: getCitroenPicturesSuccess, payload: newPictures });
        
    } catch (err) {
        console.log("err",err)
        dispatch({ type: getCitroenPicturesFailure, payload: err });
    }
}

export const setVersionSelected = (value: any) => (dispatch: Dispatch) =>  _setVersionSelected(value, dispatch);
export const _setVersionSelected = async (value: any, dispatch: Dispatch) => dispatch({ type: setVersionSelectedReducer, payload: value });


export const cleanPictures = () => (dispatch: Dispatch) =>  _cleanPictures(dispatch);
const _cleanPictures = async (dispatch: Dispatch) => dispatch({ type: cleanPicturesReducer });

export const cleanSuccessOportunitiesFetching = () => (dispatch: Dispatch) =>  _cleanSuccessOportunitiesFetching(dispatch);
const _cleanSuccessOportunitiesFetching = async (dispatch: Dispatch) => dispatch({ type: cleanSuccessOportunitiesFetchingReducer.type });
